module.exports = __webpack_public_path__ + "static/img/t5-2.9e985d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t5-2.png
// module id = es8B
// module chunks = 1